import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseMigration from "../components/ui/CaseDatabaseMigration.js";
// import CaseDatabaseCheck from "../components/ui/case-database-check.js";




export default function MigrateCaseDatabasePage(props) {
    return (

        <CurrentCaseRequired>
          <CaseDatabaseMigration  />
        </CurrentCaseRequired>

    );
}